module.exports = __webpack_public_path__ + "static/img/home_03.568fb34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/h5/home_03.png
// module id = yitb
// module chunks = 34